import { FormsModule } from '@angular/forms';
import { CaptionModule } from './../caption/caption.module';
import { DirectivesModule } from "./../shared/directives/directives.module";
import { TransitionModule } from "./../transition/transition.module";
import { ExpandableModule } from "./../expandable/expandable.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SidenavComponent } from "./sidenav.component";
import { SidenavItemComponent } from "./sidenav-item/sidenav-item.component";
import { InputModule } from "../input/input.module";
import { IconModule } from "../icon/icon.module";
import { MenuModule } from "../menu/menu.module";
import { RouterModule } from "@angular/router";

@NgModule({
	declarations: [SidenavComponent, SidenavItemComponent],
	imports: [CommonModule, InputModule, IconModule, MenuModule, RouterModule, ExpandableModule, CaptionModule, TransitionModule, DirectivesModule, FormsModule],
	exports: [SidenavComponent, SidenavItemComponent]
})
export class SidenavModule { }
